import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { datadogEnv } from '../../../../../../../../../frontend/libs/shared/src/lib/utils/pureFunctions/datadog-env.fn';

declare global {
  interface Window {
    __karma__: object;
  }
}

if (!window.__karma__) {
  const env = datadogEnv(window.location.host);

  // clientToken and site have all been updated for Datadog US1.
  datadogLogs.init({
    clientToken: 'pub873442ffb946d9bb38206fcf1833e4b5',
    env,
    site: 'datadoghq.com',
    forwardConsoleLogs: 'all',
    forwardErrorsToLogs: true,
    forwardReports: 'all',
    service: 'aptitude',
    sessionSampleRate: 100,
  });

  // applicationId, clientToken, and site have all been updated for Datadog US1.
  datadogRum.init({
    allowedTracingUrls: [
      /[\w-]+\.aptitudedev\.com|localhost:\w+|[\w-]*\.*aptitudemarketplace\.com/i,
    ],
    applicationId: 'b8bc0253-22e5-4560-9ff2-ca378ee3bef7',
    clientToken: 'pub873442ffb946d9bb38206fcf1833e4b5',
    site: 'datadoghq.com',
    service: 'aptitude-platform',
    env,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    telemetrySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackFrustrations: true,
    traceSampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.startSessionReplayRecording();
}

export default function SentryErrorHandler(error: Error) {
  console.log(error);
}
